import React from 'react';

import IncompatibleBrowserMessage from '@medipass/react-core/components/IncompatibleBrowserMessage';
import WithTitle from '@medipass/react-core/WithTitle';
type Props = {
  children: any;
  title?: string;
};
LayoutPage.defaultProps = {
  title: undefined,
};
export default function LayoutPage(props: Props) {
  const { children, title } = props;
  return (
    <WithTitle title={title}>
      <IncompatibleBrowserMessage />
      {children}
    </WithTitle>
  );
}
